const profileValidationNL = {
    "email": {
        "required": "Het e-mailadres is verplicht"
    },
    "profile_image": {
        "dimensions": "De profielfoto moet exact 300 x 300 px zijn, JPG/JPEG. Maximale bestandsgrootte 300 KB",
        "choose": "Kies alstublieft een afbeelding",
        "file": "Het geselecteerde bestand is groter dan 300 KB. Upload de afbeelding in 300x300 px, JPG/JPEG, maximale bestandsgrootte 300 KB."
    },
    "street_and_number": {
        "required": "De straat en huisnummer zijn verplicht"
    },
    "postal_code": {
        "required": "De postcode is verplicht"
    },
    "city": {
        "required": "De stad is verplicht"
    },
    "country": {
        "required": "Het land is verplicht"
    },
    "vat_number": {
        "invalid": "De waarde is geen geldig btw-nummer"
    },
    "iban": {
        "required": "IBAN is verplicht",
        "invalid": "De waarde is geen geldig IBAN-nummer"
    },
    "cardholder_name": {
        "required": "Naam kaarthouder is verplicht"
    },
    "card_number": {
        "required": "Kaartnummer is verplicht",
        "invalid": "Kaartnummer is niet geldig"
    },
    "card_year": {
        "required": "Vervaldatum jaar is verplicht",
        "invalid": "Vervaldatum jaar is niet geldig"
    },
    "card_month": {
        "required": "Vervaldatum maand is verplicht"
    },
    "cvc_code": {
        "required": "Beveiligingscode (CVC) is verplicht",
        "invalid": "Beveiligingscode (CVC) is niet geldig"
    },
    "paypal_email": {
        "required": "Paypal e-mail is verplicht",
        "invalid": "Paypal e-mail is niet geldig"
    },
    "account_holder_name": {
        "required": "Naam rekeninghouder is verplicht"
    },
    "bank_name": {
        "required": "Banknaam is verplicht"
    },
    "bank_address": {
        "required": "Bankadres is verplicht"
    },
    "preferred_payment_method": {
        "required": "Voorkeursbetaalmethode is verplicht"
    }
};

export default profileValidationNL;